/*** IMPORTS FROM imports-loader ***/
var global = window;

export {};
